import React from 'react'
import { Box } from '../../../core-components/box'

export const Empty = ({ isDisabled }: { isDisabled: boolean }) => (
  <Box
    as='svg'
    xmlns='http://www.w3.org/2000/svg'
    w={4}
    h={4}
    color={isDisabled ? 'bg/select-item-unchecked-disabled' : 'bg/select-item-unchecked'}
  >
    <path
      fill='currentColor'
      fillRule='evenodd'
      d='M12 2H4c-1.10457 0-2 .89543-2 2v8c0 1.1046.89543 2 2 2h8c1.1046 0 2-.8954 2-2V4c0-1.10457-.8954-2-2-2ZM4 0C1.79086 0 0 1.79086 0 4v8c0 2.2091 1.79086 4 4 4h8c2.2091 0 4-1.7909 4-4V4c0-2.20914-1.7909-4-4-4H4Z'
    />
  </Box>
)
